import { z } from 'zod';
import { RowLabelOptionalSchema } from './row-label';

export const PlantingTemplateSchema = z.object({
  id: z.number().int().positive(),
  company_id: z.string().uuid(),
  year: z.string().max(4).nullable().optional(),
  block_name: z.string().max(300).nullable().optional(),
  block_type: z.string().max(80).nullable().optional(),
  reference: z.string().max(100).nullable().optional(),
  crop: z.string().max(120).nullable().optional(),
  crop_variety: z.string().max(150).nullable().optional(),
  total_hectares: z.number().nullable().optional(),
  plants_per_hectare: z.number().nullable().optional(),
  plants_planted: z.number().nullable().optional(),
  planted_hectares: z.number().nullable().optional(),
  seed_supplier: z.string().max(255).nullable().optional(),
  task_status: z.string().max(100).nullable().optional(),
  labour_id: z.string().nullable().optional(),
  assigned_user: z.string().nullable().optional(),
  start_time: z.string().nullable().optional(),
  finish_time: z.string().nullable().optional(),
  start_row: RowLabelOptionalSchema,
  finish_row: RowLabelOptionalSchema,
  created_at: z.string(),
  updated_at: z.string(),
  created_by: z.string().nullable().optional(),
  updated_by: z.string().nullable().optional(),
});

export const PlantingTemplateCreateSchema = PlantingTemplateSchema.omit({
  id: true,
  company_id: true,
  created_at: true,
  updated_at: true,
}).extend({
  is_manual_entry: z.number().int().nullable().optional(),
  week: z.number().int().nullable().optional(),
  block_id: z.number().int().nullable().optional(),
  section_id: z.number().int().nullable().optional(),
  count: z.number().int().nullable().optional(),
  staff_count: z.number().int().nullable().optional(),
  pack_category: z.string().max(150).nullable().optional(),
  pack_type: z.string().max(150).nullable().optional(),
  vehicle: z.string().max(255).nullable().optional(),
  percentage: z.number().nullable().optional(),
  // Fixed irrigation: % of the start / finish bed planted (1–100). NULL = full bed.
  start_row_percentage: z.number().gt(0).max(100).nullable().optional(),
  finish_row_percentage: z.number().gt(0).max(100).nullable().optional(),
  cost_per_hour: z.number().nullable().optional(),
  labour_cost: z.number().nullable().optional(),
  task_cost: z.number().nullable().optional(),
  total_cost: z.number().nullable().optional(),
});

export const PlantingTemplateUpdateSchema = PlantingTemplateCreateSchema.partial();

export const PlantingTemplateListQuerySchema = z.object({
  search: z.string().optional(),
  block_type: z.string().optional(),
  page: z.coerce.number().int().positive().optional().default(1),
  per_page: z.coerce.number().int().positive().max(100).optional().default(25),
});

export type PlantingTemplate = z.infer<typeof PlantingTemplateSchema>;
export type PlantingTemplateCreate = z.infer<typeof PlantingTemplateCreateSchema>;
export type PlantingTemplateUpdate = z.infer<typeof PlantingTemplateUpdateSchema>;
export type PlantingTemplateListQuery = z.infer<typeof PlantingTemplateListQuerySchema>;
